/* ------------------------------------------------------------------
   BB GAME KIT - shared engine for the toddler games.
   - Bright, bouncy "kids' entertainer" voice (best voice the browser
     has, energetic pace, high warm pitch, phrases chained with a
     sing-song rhythm)
   - Sound effects: pop, ta-da fanfare, twinkle (WebAudio, no files)
   - Confetti bursts
   Exposed as window.BBKit (window.BBVoice kept for back-compat).
------------------------------------------------------------------ */
window.BBKit = (function () {

  /* ---------------- voice ---------------- */
  var voice = null;

  function rank(v) {
    var n = (v.name || '').toLowerCase();
    var l = (v.lang || '').toLowerCase().replace('_', '-');
    if (l.indexOf('en') !== 0) return -1;
    var s = 0;
    // True neural voices first - these are the only ones that sound human
    if (n.indexOf('natural') !== -1) s += 100;
    if (n.indexOf('neural') !== -1) s += 100;
    if (n.indexOf('siri') !== -1) s += 95;
    if (n.indexOf('premium') !== -1) s += 85;
    if (n.indexOf('enhanced') !== -1) s += 75;
    // Google network voices beat every plain local voice
    if (n.indexOf('google') !== -1) {
      s += 72;
      if (n.indexOf('female') !== -1 || n.indexOf('uk') !== -1 || n.indexOf('au') !== -1) s += 8;
    }
    // Plain local voices - acceptable fallbacks only
    if (n.indexOf('samantha') !== -1) s += 32;
    if (n.indexOf('catherine') !== -1) s += 30;
    if (n.indexOf('karen') !== -1) s += 28;
    if (n.indexOf('martha') !== -1) s += 26;
    if (n.indexOf('moira') !== -1) s += 24;
    if (n.indexOf('tessa') !== -1) s += 22;
    if (n.indexOf('zira') !== -1) s += 15;
    if (n.indexOf('female') !== -1) s += 8;
    if (l === 'en-au') s += 20;
    else if (l === 'en-gb') s += 14;
    else if (l === 'en-us') s += 10;
    if (n.indexOf('compact') !== -1) s -= 60;
    if (n.indexOf('fred') !== -1 || n.indexOf('albert') !== -1 || n.indexOf('zarvox') !== -1 || n.indexOf('bad news') !== -1 || n.indexOf('whisper') !== -1 || n.indexOf('bells') !== -1) s -= 100;
    return s;
  }

  function pick() {
    if (!window.speechSynthesis) return;
    var vs = speechSynthesis.getVoices();
    if (!vs || !vs.length) return;
    var best = null, bestScore = -1;
    for (var i = 0; i < vs.length; i++) {
      var sc = rank(vs[i]);
      if (sc > bestScore) { bestScore = sc; best = vs[i]; }
    }
    voice = best;
  }

  if (window.speechSynthesis) {
    pick();
    speechSynthesis.onvoiceschanged = pick;
  }

  function speak(text, opts) {
    opts = opts || {};
    if (!window.speechSynthesis) return;
    var u = new SpeechSynthesisUtterance(text);
    if (voice) u.voice = voice;
    // Natural-bright: pushing pitch too high makes every synthetic voice
    // sound metallic. Keep it close to natural and let pacing + sfx carry
    // the energy.
    u.rate = opts.rate || 1.0;
    u.pitch = opts.pitch || 1.12;
    u.volume = 1;
    speechSynthesis.speak(u);
  }

  // say('Hi!') or say(['B!', 'B says buh!', 'B is for Ball!'])
  // Arrays queue as separate phrases with bouncing pitch - a sing-song
  // rhythm the single long sentence never had.
  function say(parts, opts) {
    opts = opts || {};
    if (!window.speechSynthesis) return;
    if (typeof parts === 'string') parts = [parts];
    if (!opts.keep) speechSynthesis.cancel();
    var pitches = [1.16, 1.06, 1.12, 1.08];
    for (var i = 0; i < parts.length; i++) {
      speak(parts[i], {
        pitch: opts.pitch || pitches[i % pitches.length],
        rate: opts.rate || 1.0
      });
    }
  }

  var praiseCount = 0;
  var PRAISES = ['Hooray!', 'Wow, great job!', 'Woo hoo!', 'Amazing!', 'Fantastic!', 'You did it!'];

  // Roughly every `every` presses: returns a cheer phrase AND plays the
  // ta-da fanfare. Returns '' the rest of the time.
  function praise(every) {
    every = every || 4;
    praiseCount++;
    if (praiseCount % every === 0) {
      tada();
      return PRAISES[((praiseCount / every) | 0) % PRAISES.length];
    }
    return '';
  }

  /* ---------------- sound effects ---------------- */
  var ctx = null;

  function ac() {
    var A = window.AudioContext || window.webkitAudioContext;
    if (!A) return null;
    if (!ctx) ctx = new A();
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  }

  function tone(freq, delay, dur, type, vol) {
    var a = ac();
    if (!a) return;
    var now = a.currentTime + (delay || 0);
    var o = a.createOscillator();
    var g = a.createGain();
    o.type = type || 'sine';
    o.frequency.value = freq;
    g.gain.setValueAtTime(0, now);
    g.gain.linearRampToValueAtTime(vol || 0.16, now + 0.012);
    g.gain.exponentialRampToValueAtTime(0.001, now + dur);
    o.connect(g); g.connect(a.destination);
    o.start(now); o.stop(now + dur + 0.05);
  }

  function pop() {
    var a = ac();
    if (!a) return;
    var now = a.currentTime;
    var o = a.createOscillator();
    var g = a.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(420, now);
    o.frequency.exponentialRampToValueAtTime(900, now + 0.09);
    g.gain.setValueAtTime(0.001, now);
    g.gain.linearRampToValueAtTime(0.2, now + 0.015);
    g.gain.exponentialRampToValueAtTime(0.001, now + 0.16);
    o.connect(g); g.connect(a.destination);
    o.start(now); o.stop(now + 0.2);
  }

  function tada() {
    var notes = [523.25, 659.25, 783.99, 1046.5];
    for (var i = 0; i < notes.length; i++) tone(notes[i], i * 0.09, 0.35, 'triangle', 0.14);
  }

  function twinkle() {
    var notes = [2093, 1760, 2349];
    for (var i = 0; i < notes.length; i++) tone(notes[i], i * 0.05, 0.18, 'sine', 0.09);
  }

  /* ---------------- confetti ---------------- */
  var layer = null;

  function ensureLayer() {
    if (layer && document.body.contains(layer)) return;
    layer = document.createElement('div');
    layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:50;overflow:hidden';
    document.body.appendChild(layer);
  }

  function burst(opts) {
    opts = opts || {};
    ensureLayer();
    var n = opts.count || 18;
    var cx = opts.x != null ? opts.x : window.innerWidth / 2;
    var cy = opts.y != null ? opts.y : window.innerHeight / 2;
    var cols = opts.colours || ['#ffd700', '#ff6b81', '#4facfe', '#2ecc71', '#f1c40f', '#bb7dd8', '#ffffff'];
    var reach = Math.min(window.innerWidth, window.innerHeight) * 0.35;
    for (var i = 0; i < n; i++) {
      (function () {
        var s = document.createElement('span');
        var sz = 6 + Math.random() * 10;
        s.style.cssText =
          'position:absolute;border-radius:50%;left:' + cx + 'px;top:' + cy + 'px;' +
          'width:' + sz + 'px;height:' + sz + 'px;' +
          'background:' + cols[(Math.random() * cols.length) | 0] + ';' +
          'transition:transform 0.9s cubic-bezier(0.1,0.8,0.3,1),opacity 0.9s ease';
        layer.appendChild(s);
        var ang = Math.random() * Math.PI * 2;
        var d = 70 + Math.random() * reach;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            s.style.transform = 'translate(' + Math.cos(ang) * d + 'px,' + (Math.sin(ang) * d + 50) + 'px) rotate(' + Math.random() * 360 + 'deg) scale(0.35)';
            s.style.opacity = '0';
          });
        });
        setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 1000);
      })();
    }
  }

  return { say: say, praise: praise, pop: pop, tada: tada, twinkle: twinkle, burst: burst };
})();

/* Back-compat with the earlier BBVoice API */
window.BBVoice = {
  say: function (t, o) { window.BBKit.say(t, o); },
  praise: function (e) { return window.BBKit.praise(e); }
};
